<div class="finance-list-page bulk-cost-form-page">
  <app-page-shell>
    <p-toast position="top-center"></p-toast>
    <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

    <app-page-hero eyebrow="Payables" [title]="pageTitle" [subtitle]="subtitle">
      <div actions>
        <p-button label="Back to Queue" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (click)="cancel()"></p-button>
        <p-button label="Save Bulk Cost" icon="pi pi-save" [loading]="isSaving" (click)="save()"></p-button>
      </div>
    </app-page-hero>

    <div class="bulk-cost-form-layout">
      <div class="bulk-cost-form-main">
        <app-page-form-section icon="pi pi-building" title="Parties & Invoice"
          subtitle="Select the supplier CRM client or internal sister company, then capture invoice dates and currency.">
          <div class="formgrid grid">
            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select inputId="partyMode" [options]="[
                    { label: 'CRM Supplier', value: 'SUPPLIER' },
                    { label: 'Own Company', value: 'OWN_COMPANY' },
                    { label: 'Sister Company', value: 'SISTER_COMPANY' }
                  ]" [(ngModel)]="partyMode" (ngModelChange)="onPartyModeChange($event)" styleClass="w-full"></p-select>
                  <label for="partyMode">Party Type</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-5" *ngIf="partyMode === 'SUPPLIER'">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select inputId="crmSupplier" [options]="crmClientOptions" [(ngModel)]="selectedCrmClient"
                    optionLabel="label" optionValue="value" [filter]="true" [showClear]="true"
                    appendTo="body" styleClass="w-full" (ngModelChange)="onCrmClientChange($event)">
                    <ng-template let-option pTemplate="item">
                      <div class="option-stack">
                        <strong>{{ option.label }}</strong>
                        <small *ngIf="option.disabled">Link this CRM client to a customer/company before posting.</small>
                      </div>
                    </ng-template>
                  </p-select>
                  <label for="crmSupplier">CRM Client with Supplier Role</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-5" *ngIf="partyMode === 'SISTER_COMPANY'">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select inputId="sisterCompany" [options]="sisterCompanyOptions" [(ngModel)]="selectedSisterCompanyId"
                    [filter]="true" [showClear]="true" appendTo="body" styleClass="w-full"
                    (ngModelChange)="onSisterCompanyChange($event)">
                  </p-select>
                  <label for="sisterCompany">Sister Company</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-5" *ngIf="partyMode === 'OWN_COMPANY'">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <input id="owningCompany" pInputText [ngModel]="bulkCost.supplierName" disabled />
                  <label for="owningCompany">Owning Company</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-4">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <input id="invoiceNumber" pInputText [(ngModel)]="bulkCost.invoiceNumber" />
                  <label for="invoiceNumber">Invoice No</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-database"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select inputId="sourceType" [options]="sourceTypeOptions" [(ngModel)]="bulkCost.sourceType"
                    (ngModelChange)="onSourceTypeChange($event)" appendTo="body" styleClass="w-full"></p-select>
                  <label for="sourceType">Source Type</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-percentage"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-inputNumber inputId="exchangeRate" [(ngModel)]="bulkCost.exchangeRate"
                    [minFractionDigits]="4" [maxFractionDigits]="6" styleClass="w-full"></p-inputNumber>
                  <label for="exchangeRate">Currency Exchange Rate</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-2">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <input id="currencyCode" pInputText [(ngModel)]="bulkCost.currencyCode" maxlength="3" />
                  <label for="currencyCode">Currency</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-datePicker inputId="invoiceDate" [(ngModel)]="bulkCost.invoiceDate" dateFormat="yy-mm-dd"
                    appendTo="body" styleClass="w-full"></p-datePicker>
                  <label for="invoiceDate">Invoice Date</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-calendar-clock"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-datePicker inputId="invoiceReceivedDate" [(ngModel)]="bulkCost.invoiceReceivedDate" dateFormat="yy-mm-dd"
                    appendTo="body" styleClass="w-full"></p-datePicker>
                  <label for="invoiceReceivedDate">Invoice Received Date</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-send"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-datePicker inputId="postingDate" [(ngModel)]="bulkCost.postingDate" dateFormat="yy-mm-dd"
                    appendTo="body" styleClass="w-full"></p-datePicker>
                  <label for="postingDate">Posting Date</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-3">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-book"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select inputId="payableAccountId" [options]="accounts" [(ngModel)]="bulkCost.payableAccountId"
                    optionLabel="accountName" optionValue="accountId" [filter]="true"
                    filterBy="accountCode,accountName" appendTo="body" styleClass="w-full">
                    <ng-template let-account pTemplate="item">
                      <span>{{ accountLabel(account) }}</span>
                    </ng-template>
                  </p-select>
                  <label for="payableAccountId">Expense Account</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>
          </div>
        </app-page-form-section>

        <app-page-form-section *ngIf="bulkCost.sourceType === 'SHIPMENT_INTERNAL_COST' && (bulkCost.deliveryNumber || bulkCost.driverName || bulkCost.vehicleLabel || bulkCost.logisticsProjectNumber)"
          icon="pi pi-truck" title="Automated Delivery Context"
          subtitle="This operational snapshot is refreshed from the linked delivery and is read-only in finance.">
          <div class="automatic-context-grid">
            <div class="automatic-context-item">
              <span>Delivery</span>
              <strong>{{ bulkCost.deliveryNumber || 'Pending delivery' }}</strong>
              <small *ngIf="bulkCost.shipmentNumber">Shipment {{ bulkCost.shipmentNumber }}</small>
            </div>
            <div class="automatic-context-item">
              <span>Logistics Project</span>
              <strong>{{ projectContextLabel('Multiple projects on cost lines') }}</strong>
            </div>
            <div class="automatic-context-item">
              <span>Driver</span>
              <strong>{{ bulkCost.driverName || 'Unassigned' }}</strong>
            </div>
            <div class="automatic-context-item">
              <span>Vehicle</span>
              <strong>{{ bulkCost.vehicleLabel || 'Unassigned' }}</strong>
            </div>
          </div>
        </app-page-form-section>

        <app-page-form-section icon="pi pi-share-alt" title="Cost Allocation"
          subtitle="Choose whether each line keeps its direct amount or shares one total by percentage.">
          <div class="formgrid grid">
            <div class="field col-12 md:col-6 xl:col-4">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-sliders-h"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select inputId="allocationMode" [options]="allocationModeOptions" [(ngModel)]="bulkCost.allocationMode"
                    (ngModelChange)="onAllocationModeChange($event)" styleClass="w-full"></p-select>
                  <label for="allocationMode">Allocation Method</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-4" *ngIf="isPercentageAllocation">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-inputNumber inputId="allocationTotal" [(ngModel)]="bulkCost.allocationTotal" mode="decimal"
                    [minFractionDigits]="4" [maxFractionDigits]="4" styleClass="w-full"></p-inputNumber>
                  <label for="allocationTotal">Total Amount to Allocate</label>
                </p-iftalabel>
              </p-inputGroup>
            </div>

            <div class="field col-12 md:col-6 xl:col-4" *ngIf="isPercentageAllocation">
              <div class="allocation-balance" [class.allocation-balanced]="allocationIsBalanced()">
                <span>Line allocation total</span>
                <strong>{{ allocationPercentageTotal() | number:'1.0-4' }}%</strong>
                <small>{{ allocationIsBalanced() ? 'Balanced and ready to save' : 'Must equal 100%' }}</small>
              </div>
            </div>
          </div>
        </app-page-form-section>

        <app-page-form-section icon="pi pi-list-check" title="Cost Lines"
          [subtitle]="isPercentageAllocation ? 'Allocate the entered total across lines. Percentages must equal 100%.' : 'Assign each cost line to its logistics project, driver, vehicle, and debit account before posting.'">
          <div actions>
            <p-button label="Add Line" icon="pi pi-plus" (click)="addLine()"></p-button>
          </div>

          <div class="bulk-cost-line-stack">
            <section class="bulk-cost-line-card" *ngFor="let line of bulkCost.lines || []; let i = index">
              <div class="line-card-header">
                <div>
                  <h3>Line {{ i + 1 }}</h3>
                  <span>{{ line.sourceType || bulkCost.sourceType || 'MANUAL' }}</span>
                </div>
                <div class="line-card-actions">
                  <p-tag *ngIf="line.shipmentNumber || line.deliveryNumber" [value]="line.deliveryNumber || line.shipmentNumber" severity="info"></p-tag>
                  <p-button icon="pi pi-copy" [rounded]="true" [text]="true" pTooltip="Duplicate"
                    (click)="duplicateLine(line)"></p-button>
                  <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" pTooltip="Remove"
                    (click)="removeLine(i)"></p-button>
                </div>
              </div>

              <div class="formgrid grid">
                <div class="field col-12 md:col-6 xl:col-4">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                    <p-iftalabel>
                    <app-logistics-project-lookup [inputId]="'logisticsProject' + i"
                        [(ngModel)]="line.logisticsProjectId" (projectSelected)="onProjectChange(line, $event)"></app-logistics-project-lookup>
                      <label [for]="'logisticsProject' + i">Logistics Project</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-2">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-select [inputId]="'driver' + i" [options]="driverOptions"
                        [(ngModel)]="line.driverId" [filter]="true" [showClear]="true" appendTo="body"
                        styleClass="w-full" (ngModelChange)="onDriverChange(line, $event)">
                      </p-select>
                      <label [for]="'driver' + i">Driver</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-3">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-select [inputId]="'vehicle' + i" [options]="vehicleOptions"
                        [(ngModel)]="line.vehicleId" [filter]="true" [showClear]="true" appendTo="body"
                        styleClass="w-full" (ngModelChange)="onVehicleChange(line, $event)">
                      </p-select>
                      <label [for]="'vehicle' + i">Vehicle</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-3">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-book"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-select [inputId]="'accountId' + i" [options]="accounts" [(ngModel)]="line.accountId"
                        optionLabel="accountName" optionValue="accountId" [filter]="true"
                        filterBy="accountCode,accountName" appendTo="body" styleClass="w-full">
                        <ng-template let-account pTemplate="item">
                          <span>{{ accountLabel(account) }}</span>
                        </ng-template>
                      </p-select>
                      <label [for]="'accountId' + i">Debit Account</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-6">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <input [id]="'description' + i" pInputText [(ngModel)]="line.description" />
                      <label [for]="'description' + i">Description</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-2" *ngIf="!isPercentageAllocation">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <input [id]="'unit' + i" pInputText [(ngModel)]="line.unit" />
                      <label [for]="'unit' + i">Unit</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-2" *ngIf="!isPercentageAllocation">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-calculator"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-inputNumber [inputId]="'quantity' + i" [(ngModel)]="line.quantity"
                        [minFractionDigits]="2" [maxFractionDigits]="4" styleClass="w-full"></p-inputNumber>
                      <label [for]="'quantity' + i">Qty</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-2" *ngIf="!isPercentageAllocation">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-dollar"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-inputNumber [inputId]="'price' + i" [(ngModel)]="line.price" mode="decimal"
                        [minFractionDigits]="4" [maxFractionDigits]="4" styleClass="w-full"></p-inputNumber>
                      <label [for]="'price' + i">Price</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-3" *ngIf="isPercentageAllocation">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-percentage"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-inputNumber [inputId]="'allocationPercentage' + i" [(ngModel)]="line.allocationPercentage"
                        [min]="0" [max]="100" [minFractionDigits]="2" [maxFractionDigits]="4" suffix="%" styleClass="w-full"></p-inputNumber>
                      <label [for]="'allocationPercentage' + i">Allocation Share</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-3" *ngIf="isPercentageAllocation">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-calculator"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <input [id]="'allocatedAmount' + i" pInputText [ngModel]="formatMoney(lineAmount(line, i))" disabled />
                      <label [for]="'allocatedAmount' + i">Allocated Amount</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-2">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-percentage"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <p-inputNumber [inputId]="'taxAmount' + i" [(ngModel)]="line.taxAmount" mode="decimal"
                        [minFractionDigits]="4" [maxFractionDigits]="4" styleClass="w-full"></p-inputNumber>
                      <label [for]="'taxAmount' + i">Tax</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6 xl:col-4">
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
                    <p-iftalabel>
                      <textarea [id]="'comments' + i" pTextarea [(ngModel)]="line.comments" rows="1"></textarea>
                      <label [for]="'comments' + i">Comments</label>
                    </p-iftalabel>
                  </p-inputGroup>
                </div>
              </div>

              <div class="line-card-total">
                <span>Line Amount</span>
                <strong>{{ formatMoney(lineTotal(line, i)) }}</strong>
                <small>VAT {{ formatMoney(line.taxAmount) }}</small>
              </div>
            </section>
          </div>
        </app-page-form-section>
      </div>

      <aside class="bulk-cost-review-aside">
        <section class="review-panel">
          <span>Review &amp; Save</span>
          <strong>{{ formatMoney(totalLocal()) }}</strong>
          <p>{{ bulkCost.lines?.length || 0 }} cost lines</p>
          <div class="review-breakdown">
            <div><span>Total Amount</span><strong>{{ formatMoney(totalAmount()) }}</strong></div>
            <div><span>Total Tax</span><strong>{{ formatMoney(totalTax()) }}</strong></div>
            <div><span>Local Amount</span><strong>{{ formatMoney(totalLocal()) }}</strong></div>
          </div>
          <label class="include-tax-row">
            <span>
              <strong>Include Tax</strong>
              <small>Local totals include line tax during posting.</small>
            </span>
            <p-checkbox [(ngModel)]="bulkCost.includeTax" [binary]="true"></p-checkbox>
          </label>
          <p-button label="Save Bulk Cost" icon="pi pi-save" [loading]="isSaving" styleClass="w-full" (click)="save()"></p-button>
          <p-button label="Cancel" severity="secondary" [outlined]="true" styleClass="w-full" (click)="cancel()"></p-button>
        </section>
      </aside>
    </div>
  </app-page-shell>
</div>
